import styled from 'styled-components';
import DefaultModal from 'components/Modals/Modal';
import { Subtitle } from 'components/Typography';
import { FiAlertTriangle } from 'react-icons/fi';
import DefaultButton from 'components/Buttons/Button';

export const Modal = styled(DefaultModal)``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0rem;
  width: 22.75rem;
  min-height: 9.625rem;
`;

export const WarningIcon = styled(FiAlertTriangle)`
  width: 2rem;
  height: 2rem;
  margin-bottom: 1.6875rem;
  color: ${({ theme }) => theme.colors.yellowMedium};
`;

// TODO: TFR-45:Text make unique name or do not export
export const Text = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-top: 1rem;
  text-align: center;
  font-weight: 700;
`;

// TODO: TFR-45:WrapperButton make unique name or do not export
export const WrapperButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 2.25rem;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  width: 10.875rem;
`;
